import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "v-btn__content" }
const _hoisted_2 = { class: "ms-5 mb-2" }
const _hoisted_3 = {
  key: 0,
  class: "text-sm-body-2 text-red mb-2"
}

import { ref, computed, onMounted } from 'vue'
import ReviewForm from '../../../api/v2/forms/review'
import Simplemde from '../atoms_molecules/Simplemde.vue'
import { userState } from '../../stores/user'
import { checkMobile } from '../../utils/utils'
import { reviewState } from '../../stores/reviews'
import Review from '../../../api/v2/models/review'


export default /*@__PURE__*/_defineComponent({
  __name: 'ReviewEditDialog',
  props: {
    courseId: { default: '' },
    review: {},
    enrollmentId: { default: '' }
  },
  setup(__props: any) {

const props = __props

const dialog = ref(false)
const body = ref('')
const rank = ref(0)
const hasReview = ref(false)
const invalidBody = ref(false)
const isNotConfirm = ref(true)
const confirmed = ref(false)
const mobile = checkMobile()

const user = computed(() => userState.user)

const currentTime = computed(() => {
  var today = new Date()
  return `${today.getFullYear()}-${(today.getMonth()+1)}-${today.getDate()}`
})

const updateReview = async () => {
  invalidBody.value = !body.value
  if (invalidBody.value) return
  isNotConfirm.value = false
  const reviewForm = new ReviewForm()

  reviewForm.rank = rank.value
  reviewForm.body = body.value

  await reviewState.update(props.review!.id, reviewForm)

  setTimeout(() => {
    isNotConfirm.value = true
    dialog.value = false
  }, 3000)
}

onMounted(() => {
  if (props.review) {
    body.value = props.review.body
    rank.value = props.review.rank
  }
})

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_rating = _resolveComponent("v-rating")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: dialog.value,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((dialog).value = $event)),
    "max-width": "590"
  }, {
    activator: _withCtx(({ props }) => [
      _createVNode(_component_v_btn, _mergeProps({ class: "v-btn v-btn--contained theme--dark" }, props, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => {hasReview.value = false;})
      }), {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_1, [
            _createVNode(_component_v_icon, { class: "me-1" }, {
              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                _createTextVNode("mdi-star", -1 /* CACHED */)
              ]))]),
              _: 1 /* STABLE */
            }),
            _cache[7] || (_cache[7] = _createTextVNode("評価する ", -1 /* CACHED */))
          ])
        ]),
        _: 1 /* STABLE */
      }, 16 /* FULL_PROPS */)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        class: "user-question-dialog pb-4",
        style: {"text-align":"center"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, {
            class: "headline",
            style: {"padding-left":"33%"}
          }, {
            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
              _createTextVNode("この評価を編集します", -1 /* CACHED */)
            ]))]),
            _: 1 /* STABLE */
          }),
          (isNotConfirm.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_v_rating, {
                    modelValue: rank.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((rank).value = $event)),
                    color: "yellow accent-4",
                    density: "compact",
                    hover: "",
                    size: "32"
                  }, null, 8 /* PROPS */, ["modelValue"])
                ]),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    (invalidBody.value)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_3, "内容を入力してください"))
                      : _createCommentVNode("v-if", true),
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((body).value = $event)),
                      placeholder: "レビュー内容を入力してください",
                      rows: "5",
                      class: "review-body"
                    }, null, 512 /* NEED_PATCH */), [
                      [_vModelText, body.value]
                    ]),
                    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "d-flex" }, null, -1 /* CACHED */))
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_v_card_actions, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_v_btn, {
                      color: "green",
                      onClick: updateReview
                    }, {
                      default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                        _createTextVNode(" レビュー編集する ", -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    }),
                    _createVNode(_component_v_btn, {
                      color: "green-darken-1",
                      text: "",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (dialog.value = false))
                    }, {
                      default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                        _createTextVNode("キャンセル ", -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                })
              ], 64 /* STABLE_FRAGMENT */))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                    _createElementVNode("h2", { class: "mt-3 ms-10" }, " ありがとうございます。", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_v_card_actions, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_v_btn, {
                      color: "green-darken-1",
                      text: "",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (dialog.value = false))
                    }, {
                      default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                        _createTextVNode("閉じる ", -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                })
              ], 64 /* STABLE_FRAGMENT */))
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["modelValue"]))
}
}

})